module.exports = __webpack_public_path__ + "static/media/TipScreen.e6e4523a.png";